import { isFipsRegion } from "./isFipsRegion";
export var getRealRegion = function (region) {
    return isFipsRegion(region)
        ? ["fips-aws-global", "aws-fips"].includes(region)
            ? "us-east-1"
            : region.replace(/fips-(dkr-|prod-)?|-fips/, "")
        : region;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/config-resolver/dist-es/regionConfig/getRealRegion.js
// module id = 665
// module chunks = 0